import React from 'react';
import { stats, universities } from '../data/content';
export function ProofBar() {
  return <section className="w-full bg-blue-50 py-14 md:py-20" data-id="element-202" data-mp="mahzio4mcyj4">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-203" data-mp="mc1g6fu6tblf">
        <dl className="grid grid-cols-2 gap-8 text-center md:grid-cols-4" data-id="element-204" data-mp="7kauba3mhc0d">
          {stats.map(stat => <div key={stat.label} data-id="element-205" data-mp="cikphkpckclz">
              <dt className="sr-only" data-id="element-206" data-mp="3upryvoh4jpn7">{stat.label}</dt>
              <dd data-id="element-207" data-mp="3uoyxl30xpscg">
                <span className="block font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl" data-id="element-208" data-mp="3uruzf2fwl166">
                  {stat.value}
                </span>
                <span className="mx-auto mt-1 block max-w-[14rem] text-sm font-semibold text-blue-700" data-id="element-209" data-mp="3ksnk49plywgf">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 border-t border-blue-200/70 pt-8 text-center" data-id="element-210" data-mp="1j0r3ilol2wes">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-blue-600" data-id="element-211" data-mp="1ny9cgc2lpbms">
            Usado en 15+ universidades latinoamericanas
          </p>
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-3" data-id="element-212" data-mp="2ngdkvn5w787s">
            {universities.map(university => <li key={university} className="rounded-full bg-white px-4 py-1.5 font-display text-sm font-extrabold tracking-tight text-blue-800 ring-1 ring-blue-200" data-id="element-213" data-mp="323gkbzdrzqxr">
                {university}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}